import React from "react"
import glamorous from "glamorous"
import style from "utils/style"

const SectionHeader = ({ title }) => (
  <div>
    <HR />
    <Title>{title}</Title>
  </div>
)

export default SectionHeader

const HR = glamorous.hr({
  borderTopWidth: 1,
  borderTopStyle: "solid",
  borderTopColor: style.colors.darkerGray,
})

const Title = glamorous.span({
  position: "relative",
  top: -20,
  fontSize: "1.2rem",
  color: style.colors.anotherGray,
  fontWeight: 600,
  backgroundColor: "white",
  marginLeft: "20%",
  padding: "0 5%",
  [style.size.mobile]: {
    marginLeft: 0,
    paddingLeft: 0,
  },
})



// WEBPACK FOOTER //
// ./src/components/Form/FormFields/SectionHeader/index.js